import React from 'react'
import './MenuLanguage.scss'
import MenuLanguageItem from './MenuLanguageItem'
import {useI18next} from 'gatsby-plugin-react-i18next'
import MenuDropdown from './MenuDropdown'
import MenuLanguageDropdownTitle from './MenuLanguageDropdownTitle'

const MenuLanguage = () => {
    const {language, languages} = useI18next()

    return (
        <MenuDropdown
            title={<MenuLanguageDropdownTitle languageText={languageTextMap[language]} />}
            isFullWidth={false}
            isRight={true}
        >
            {languages.map((language) => (
                <MenuLanguageItem key={language} language={language} text={languageTextMap[language]} />
            ))}
        </MenuDropdown>
    )
}

const languageTextMap = {
    pl: 'Polski',
    en: 'English',
    de: 'Deutsch',
    it: 'Italiano',
}

export default MenuLanguage
